import { componentsConfig } from './componentsConfig';
import { wrapComponentWithHOCs } from './wrapComponentWithHOCs';
/**
 * @template P
 * @typedef {import('react').ComponentType<P>} FC
 */

/**
 * @typedef {Object} EzloPluginsAddButtonProps
 * @property {string} title
 * @property {function} onClick
 */

/**
 * @typedef {Object} CreateNotificationTemplateButtonProps
 * @property {function} onClickCreateNewTemplateButton
 */

/**
 * @typedef {Object} CreateBackupButtonProps
 * @property {function} handleOpenCreateBackupModal
 * @property {boolean} isCurrentControllerConnected
 */

/**
 * @typedef {Object} RestoreBackupButtonProps
 * @property {function} handleOpenRestoreBackupModal
 */

/**
 * @typedef {Object} VirtualDeviceActionsProps
 * @property {function} handleOpenConfirmationModal
 * @property {function} handleEdit
 */

/**
 * @typedef {Object} ExpressionItemActionsProps
 * @property {function} handleDeleteExpression
 * @property {function} handleEditClick
 * @property {string} name
 */

/**
 * @typedef {Object} DeviceSettingsProps
 * @property {Object} device
 * @property {boolean} isAvailable
 * @property {boolean} isConnected
 * @property {Array} settings
 * @property {function} onHandlerSelectFunction
 * @property {boolean} isIntegration
 */

/**
 * @typedef {Object} ComponentsMap
 * @property {FC<EzloPluginsAddButtonProps>} EzloPluginsAddButton
 * @property {FC<any>} UpgradePluginIcon
 * @property {FC<CreateNotificationTemplateButtonProps>} CreateNotificationTemplateButton
 * @property {FC<DeviceSettingsProps>} DeviceSettings
 * @property {FC<CreateBackupButtonProps>} CreateBackupButton
 * @property {FC<RestoreBackupButtonProps>} RestoreBackupButton
 * @property {FC<VirtualDeviceActionsProps>} VirtualDeviceActions
 * @property {FC<ExpressionItemActionsProps>} ExpressionItemActions
 * @property {FC<any>} CreateContainerButton
 */

/**
 * An object containing all enhanced UI components, each wrapped with the required HOCs as specified in the config.
 *
 * This object is automatically generated from `componentsConfig`. Each key corresponds to the component's name,
 * and each value is the enhanced (wrapped) component—e.g., with permission guards.
 *
 * @type {ComponentsMap}
 *
 * @example
 * import { Components } from './enhancedComponents';
 *
 * // Use an enhanced component (e.g., with permission checks)
 * <Components.EzloPluginsAddButton {...props} />
 */
export const Components = Object.fromEntries(
    Object.entries(componentsConfig).map(([key, config]) => [key, wrapComponentWithHOCs(config)]),
);
